import { Box, Card, Skeleton, Typography } from "@mui/material";
import Loading from "../../load/loading";
import HeaderGestorConfigs from "../../utils/headerGestorConfigs";
import QRCode from "../../qrCode/qrCode";
import DadosPessoalEdit from "../dadosGenericos/dadosPessoalEdit";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import printerService from "../../services/printer";
import FotoEdit from "../../utils/fotoEdit";
import ChangeStatusAdmin from "./changeStatusAdmin";
import AssinaturaUser from "./assinaturaUser";
import CarimboUser from "./carimboUser";
import EditeSenha from "./editeSenha";
import api from "../../services/api";
import GerenciarPrivilegios from "./privilegios/gerenciarPrivilegios";
import './fichaAdmin.css';
import ShortNome from "../../utils/ShortNome";
import { useParams } from "react-router-dom";
import VerifyPermission from "../../utils/verifyPermission";

export default function FichaAdmin({ admin, local, setHandleUpdate, list }) {
  const user = useSelector((state) => state.account.user);
  const [editDados, setEditDados] = useState(false);
  const [dadosPessoalAdmin, setDadosPessoalAdmin] = useState(admin);
  const [openEditFoto, setOpenEditFoto] = useState(false);
  const [openRepresentante, setOpenRepresentante] = useState(false)
  const [openConfirm, setOpenConfirm] = useState(false)
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoad] = useState(false);
  const [messegeSuccess, setMessageSuccess] = useState('');
  const [messegeError, setMessageError] = useState('');
  const baseUrl = window.location.origin;
  const { id } = useParams()

  const [dadosRepresentante, setDadosRepresentante] = useState({
    userId: user?._id,
    ordem: '',
    numeroCarteira: '',
    adminId: dadosPessoalAdmin?._id,
    categoriaId: ''
  })

  const handleCloseRepresentante = () => { setOpenRepresentante(false) }
  const handleCloseConfirm = () => { setOpenConfirm(false) }

  useEffect(() => {
    api.get('/categoria-tecnico')
      .then((res) => setCategorias(res.data.categoriaTecnicos))
      .catch((err) => 'console.log(err)')
  }, [])

  const changeToRepresentante = () => {
    setLoad(true);
    api.post('/admin/become-representante', {
      adminId: dadosPessoalAdmin?._id,
      userId: user?._id
    })
      .then((res) => setMessageSuccess('O usuário agora é um representante'))
      .catch(() => setMessageError('Não foi Possivel tornar - lo representante'))
      .finally(() => setLoad(false))
  }
  const changeToDirectorTecnico = () => {
    setLoad(true);
    api.post('/admin/become-tecnico', dadosRepresentante)
      .then((res) => {
        handleCloseConfirm();
        setMessageSuccess('Usuário aprovado como Director Técnico')
      })
      .catch((err) => {
        handleCloseConfirm();
        setMessageError(err.response.data.msg)
      })
      .finally(() => setLoad(false))
  }

  const handleChange = (event) => {
    setDadosRepresentante({ ...dadosRepresentante, [event.target.name]: event.target.value });
  }


  const printQrCode = (qrCodeAdmin) => {
    var preview = document.getElementById(qrCodeAdmin);
    preview.style = "display:  ";
    printerService.printer(qrCodeAdmin);
    preview.style = "display: none";
  };

  return (
    <>
      <br />

      {admin ? (
        <Card style={{ padding: 10, minHeight: "20vh", width: list === true ? '48%' : '100%' }}>
          <HeaderGestorConfigs
            menu={local === "perfilAdmin" ? true : false}
            configArea={"fichaAdmin"}
            title={
              <>
                <ShortNome nome={dadosPessoalAdmin?.dadosPessoais?.nome} />{" "}
                ( {dadosPessoalAdmin?.funcao} )
              </>
            }
            editDados={editDados}
            setEditDados={setEditDados}
            dadosPessoalAdmin={dadosPessoalAdmin}
            setOpenEditFoto={setOpenEditFoto}
            printQrCode={printQrCode}
            openRepresentante={openRepresentante}
            setOpenRepresentante={setOpenRepresentante}
            openConfirm={openConfirm}
            setOpenConfirm={setOpenConfirm}
            categorias={categorias}
            dadosRepresentante={dadosRepresentante}
            setDadosRepresentante={setDadosRepresentante}
            handleCloseRepresentante={handleCloseRepresentante}
            handleCloseConfirm={handleCloseConfirm}
            changeToRepresentante={changeToRepresentante}
            changeToDirectorTecnico={changeToDirectorTecnico}
            handleChange={handleChange}
            load={loading}
            messegeSuccess={messegeSuccess}
            messegeError={messegeError}
          />

          {!editDados && (
            <Box className="profile-container">
              <div className="profile-card">
                {/* <div className='`${adminUrl ? profile-card-content}`'> */}
                <div className={`${list === true ? "profile-card-content-1" : "profile-card-content"}`}>
                  {/* Image Section */}
                  <div className="profile-image-section">
                    {loading ? (
                      <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />
                    ) : (
                      <>
                        <img
                          src={dadosPessoalAdmin?.dadosPessoais?.fotoURL}
                          alt="Profile"
                          className="profile-image"
                        />

                        <FotoEdit
                          openEditFoto={openEditFoto}
                          setOpenEditFoto={setOpenEditFoto}
                          dadosPessoais={dadosPessoalAdmin?.dadosPessoais}
                          viewEdit={true}
                        />
                      </>
                    )}

                    <div className="profile-function-badge">
                      <div className="profile-function-badge-inner">
                        <Typography
                          style={{
                            borderRadius: 5,
                            background: "#99288b",
                            color: "#fff",
                            padding: 5,
                          }}
                          align="center"
                          variant="subtitle1"
                        >
                          <strong>Função: </strong>
                          {dadosPessoalAdmin?.funcao}
                        </Typography>
                      </div>
                    </div>
                  </div>

                  <div className="profile-info-section">
                    <div className="profile-qr-container">
                      <div className="profile-qr-box">
                        {loading ? (
                          <Skeleton variant="rectangular" width={80} height={80} animation="wave" />
                        ) : (
                          <QRCode
                            link={`${baseUrl}/verifica-tecnico/${dadosPessoalAdmin?._id}`}
                            style={{ width: 40, height: 40, color: '#374151' }}
                          />
                        )}
                      </div>
                    </div>

                    <div className="profile-info-content">
                      <div className="profile-name-section">
                        {loading ? (
                          <Skeleton variant="text" width={200} height={60} animation="wave" />
                        ) : (
                          <h1 className="profile-name-title">
                            {dadosPessoalAdmin?.dadosPessoais?.nome || "N/A"}
                          </h1>
                        )}
                        <div className="profile-name-underline"></div>
                      </div>

                      {loading ? (
                        <>
                          <Skeleton variant="text" width={180} height={20} animation="wave" />
                          <Skeleton variant="text" width={180} height={20} animation="wave" />
                        </>
                      ) : (
                        <div className="profile-details-section">
                          <div className="profile-details-list">
                            <p className="profile-detail-item">
                              <strong>Departamento:</strong> {dadosPessoalAdmin?.departamento || "N/A"}
                            </p>
                            <p className="profile-detail-item">
                              <strong>Secção:</strong> {dadosPessoalAdmin?.seccao || "N/A"}
                            </p>
                            <p className="profile-detail-item">
                              <strong>Agente:</strong> {dadosPessoalAdmin?.numeroAgente || "N/A"}
                            </p>
                            <p className="profile-detail-item">
                              <strong>BI:</strong> {dadosPessoalAdmin?.dadosPessoais?.numeroBI || "N/A"}
                            </p>
                            <p className="profile-detail-item">
                              <strong>E-mail Pessoal:</strong> {dadosPessoalAdmin?.dadosPessoais?.email || "N/A"}
                            </p>
                            <p className="profile-detail-item">
                              <strong>Telefone1:</strong> {dadosPessoalAdmin?.dadosPessoais?.tel1 || "N/A"}
                            </p>
                            <p className="profile-detail-item">
                              <strong>Telefone2:</strong> {dadosPessoalAdmin?.dadosPessoais?.tel2 || "N/A"}
                            </p>
                            <p className="profile-detail-item">
                              <strong>Rua:</strong> {dadosPessoalAdmin?.dadosPessoais?.rua || "N/A"}
                            </p>
                            <p className="profile-detail-item">
                              <strong>Bairro:</strong> {dadosPessoalAdmin?.dadosPessoais?.bairro || "N/A"}
                            </p>
                            <p className="profile-detail-item">
                              <strong>Distrito:</strong> {dadosPessoalAdmin?.dadosPessoais?.municipio || "N/A"}
                            </p>
                            <p className="profile-detail-item">
                              <strong>Província:</strong> {dadosPessoalAdmin?.dadosPessoais?.provincia || "N/A"}
                            </p>
                          </div>

                          {id &&
                            <VerifyPermission permissions={user?.permissions} permission={'allPermission'}>
                              <div className="profile-action-buttons">
                                <ChangeStatusAdmin
                                  admin={admin}
                                  setHandleUpdate={setHandleUpdate}
                                />
                                <AssinaturaUser
                                  admin={admin}
                                  setHandleUpdate={setHandleUpdate}
                                />
                                <CarimboUser
                                  admin={admin}
                                  setHandleUpdate={setHandleUpdate}
                                />
                              </div>
                            </VerifyPermission>
                          }

                          {dadosPessoalAdmin?.assinatura && (
                            <div className="profile-signature">
                              <img
                                src={dadosPessoalAdmin?.assinatura}
                                alt="Assinatura"
                              />
                            </div>
                          )}
                          
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          )}

          {editDados === "dadosPessoais" && (
            <DadosPessoalEdit
              dadosPessoais={dadosPessoalAdmin.dadosPessoais}
              setDadosPessoais={setDadosPessoalAdmin}
              cancelEditDados={setEditDados}
            />
          )}

          {editDados === "senha" && (
            <EditeSenha user={admin} cancelEdite={setEditDados} />
          )}

          {editDados === "gerenciarPrivilegios" && (
            <GerenciarPrivilegios user={admin} cancelEditPrivilegios={setEditDados} />
          )}
        </Card>
      ) : (
        <Loading />
      )}
    </>
  );
}
